import { Paper, Stack } from '@mui/material'
import styles from '@/components/Settings/GeneralSettingsContent.module.scss'
import { GeneralSettingsProfileFields } from './GeneralSettingsProfileFields'
import { GeneralSettingsSection } from './GeneralSettingsSection'

/**
 * @param {{
 *   paperSingle: string, email: string, firstName: string, lastName: string,
 *   onFirstNameChange: (v: string) => void, onLastNameChange: (v: string) => void,
 * }} props
 */
export function GeneralSettingsProfileSection({ paperSingle, email, firstName, lastName, onFirstNameChange, onLastNameChange }) {
  return (
    <GeneralSettingsSection title="Profile" introKey="general-profile">
      <Paper elevation={0} className={paperSingle}>
        <Stack className={styles.profileFields}>
          <GeneralSettingsProfileFields email={email} firstName={firstName} lastName={lastName} onFirstNameChange={onFirstNameChange} onLastNameChange={onLastNameChange} />
        </Stack>
      </Paper>
    </GeneralSettingsSection>
  )
}
